import React from 'react';
import NlimsDataTable from '../../shared/NlimsDataTable/NlimsDataTable';
import { vaccinationRecordsApi } from '../../../api/animalHealthApi';
import { useAnimalHealthRecords } from '../hooks/useAnimalHealthRecords';

const COLD_CHAIN_STYLE = {
  Maintained: 'background:#dcfce7;color:#15803d;border:1px solid #86efac;',
  Compromised: 'background:#fff1f2;color:#be123c;border:1px solid #fecdd3;',
  Unknown: 'background:#fef3c7;color:#b45309;border:1px solid #fcd34d;',
};

function coldChainStatusHtml(data, type) {
  if (type !== 'display') return data ?? '';
  const s = COLD_CHAIN_STYLE[data] || 'background:#f3f4f6;color:#6b7280;';
  return `<span style="display:inline-flex;padding:2px 10px;border-radius:6px;font-size:11px;font-weight:600;${s}">${data || '-'}</span>`;
}

function coldChainComplianceHtml(data, type) {
  if (type !== 'display') return data ?? '';
  const num = parseInt(data, 10);
  const color = num >= 95 ? '#15803d' : '#dc2626';
  return `<span style="font-weight:700;color:${color};">${data}</span>`;
}

const COLUMNS = [
  { title: 'Disease Target', data: 'diseaseTarget', sortable: true },
  { title: 'Livestock Species', data: 'species', sortable: true },
  { title: 'State/LGA', data: 'stateLGA', sortable: true },
  { title: 'Target Population', data: 'targetPop', sortable: true },
  { title: 'Animals Vaccinated', data: 'animalsVaccinated', sortable: true },
  { title: 'Coverage Rate %', data: 'coverageRate', sortable: true },
  { title: 'Doses', data: 'doses', sortable: true },
  { title: 'Vaccine Batch Number', data: 'batchNo', sortable: true },
  { title: 'Implementing Institution', data: 'institution', sortable: true },
  { title: 'Cold Chain Status', data: 'coldChainStatus', sortable: true, render: coldChainStatusHtml },
  { title: 'Campaign Status', data: 'campaignStatus', sortable: true },
  { title: 'Cold Chain Compliance', data: 'coldChainCompliance', sortable: true, render: coldChainComplianceHtml },
];

export default function VaccinationRecordsTab({ searchQuery = '' }) {
  const { filteredRecords, loading, error } = useAnimalHealthRecords(vaccinationRecordsApi, searchQuery);

  return (
    <div className="space-y-3">
      {loading && (
        <div className="rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-700">
          Loading vaccination records...
        </div>
      )}
      {error && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}
      <NlimsDataTable
        tableId="vaccination-records-table"
        columns={COLUMNS}
        data={filteredRecords}
        serverSide={false}
        hideSearch
        pageLength={10}
        enableRowSelection
      />
    </div>
  );
}
